
import { isReactive, toRaw } from 'vue'

export default class Helpers {
  public enableLogging:boolean = false;

  constructor() {

  }

  public log(value:any) {
    console.log(value);
    // if(this.enableLogging == true)
    //     console.log(value);
  }

  public error(value:any) {
    if (this.enableLogging == true) console.error(value);
  }

  public info(value:any) {
    if (this.enableLogging == true) console.info(value);
  }


  public isObject (value: unknown): boolean {
    return value !== null && !Array.isArray(value) && typeof value === 'object'
  }
  
  public getRawData<T>(data: T): T {
    return isReactive(data) ? toRaw(data) : data
  }
  
  public toDeepRaw<T>(data: T): T {
    const rawData = this.getRawData<T>(data)
  
    for (const key in rawData) {
      const value = rawData[key]
  
      if (!this.isObject(value) && !Array.isArray(value)) {
        continue
      }
  
      rawData[key] = this.toDeepRaw<typeof value>(value)
    }
  
    return rawData // much better: structuredClone(rawData)
  }
  
}
